/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Agent_Knowledge_Chip2_LabelInputs */



/**
* | output |
* | --- |
* | "Can people see spaces through the agent?" |
*
* @param {Uno_Edu_Agent_Knowledge_Chip2_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_agent_knowledge_chip2_label = /** @type {((inputs?: Uno_Edu_Agent_Knowledge_Chip2_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Agent_Knowledge_Chip2_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sehen andere über den Agenten meine Bereiche?")
	return /** @type {LocalizedString} */ ("Can people see spaces through the agent?")
});